<div class="modal-body" id="modal-body">
  <ng-container *ngIf="contentType === 'detail'; else listBlock">
    <app-payment-terms-detail [pk]="pk" [mode]="mode" [defaults]="defaults"
                              (detailSaved)="modal.close($event)"
                              (detailCancelled)="modal.dismiss()">
    </app-payment-terms-detail>
  </ng-container>
  <ng-template #listBlock>
    <app-payment-terms-list (rowClick)="modal.close($event)" [disableUrlUpdate]="true"
                            [disabledButtons]="localDisabledButtons" [disabledColumns]="disabledColumns"
                            [filters]="filters" [disableRouterLink]="true">
    </app-payment-terms-list>
  </ng-template>
</div>